import React, { Component } from "react";
import { connect } from "react-redux";
import YETwoSecondLeft from "./YETwoSecondLeft";
import YETwoSecondLeftV2 from "./YETwoSecondLeftV2";
import YETwoSecondRight from "./YETwoSecondRight";
import YETwoSecondRightV2 from "./YETwoSecondRightV2";
import QVFourSecondLeft from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourSecondPage/QVFourSecondLeft";
import SecondPageComponents from "views/Pma/PmaEditor/SecondPageComponents";
import BubbleCompareSecondLeft from "views/Pma/PmaEditor/BubbleCompare/BubbleCompareSecondPage/BubbleCompareSecondLeft";
import MQThreeSecondLeft from "views/Pma/PmaEditor/MidQuarter/MQThree/MQThreeSecondPage/MQThreeSecondLeft";
import TableQuadrantsSecondLeft from "views/Pma/PmaEditor/TableQuadrants/TableQuadrantsPageTwo/TableQuadrantsSecondLeft";
import MiniTableHotBoxesSecondLeft from "./MiniTableHotBoxesSecondLeft";
import YETwoFirstLeft from "../YETwoFirstPage/YETwoFirstLeft";

class YETwoSecondPage extends Component {
  render() {
    const {
      auth,
      agentData,
      hoData,
      currentArea,
      printVersion,
      fromEditor,
      version,
      salePriceForCities,
      MQCityDetails,
      mlsAreas,
      qArea,
      qCity,
      aprilData,
      quarterlyAreaTable,
      quarterlyCityTable,
      propertyData,
      pmaQuarterlyCombinedCityDTO,
      propertyPhotoDetailsDTO,
      oldPhotoDetails,
      photoTableData,
      isDemo,
      missionStatement,
      hasFlippedTeam,
      dashboardValuation,
      demoAccountHOName,
      demoAccountAreaName,
      coverPageDetails,
      testimonials,
      handlePropertyHighlightDialog,
      bubbleBoxes,
      quadrantDetails,
      agentFocusInfoList,
      designDetailsInfoList,
      tpTrends2WatchList,
      quadrantModalOpen,
      altAgentData,
      volunteerDetails,
      miniTableDetailsDTO,
      showAllEditButtons,
      keyMarketAvgsList,
      showMedian,
      priceRangeDashBoardDetailsDTOArea,
      priceRangeDashBoardDetailsDTOCity,
    } = this.props;

    const { mlsAreaID } = currentArea;
    const { listgenUserID, pmaScheduleID } = agentData;

    if (fromEditor && printVersion) {
      return (
        <div
          className={
            "pma-page-container " +
            (printVersion
              ? "ye2-print-page-container"
              : "ye2-pma-editor-page-container") +
            (fromEditor ? " from-editor-column" : "")
          }
        >
          {/*  <SecondPageComponents
        currentArea={currentArea}
        hoData={hoData}
        agentData={agentData}
        printVersion={printVersion}
        fromEditor={fromEditor}
        quarterlyAreaTable={quarterlyAreaTable}
        quarterlyCityTable={quarterlyCityTable}
        hasFlippedTeam={hasFlippedTeam}
        aprilData={aprilData}
        MQCityDetails={MQCityDetails}
        dashboardValuation={dashboardValuation}
      /> */}

          {/* <YETwoSecondLeft
        currentArea={currentArea}
        agentData={agentData}
        printVersion={printVersion}
        version={version}
        mlsAreas={mlsAreas}
        hoData={hoData}
        quarterlyAreaTable={quarterlyAreaTable}
        propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
        oldPhotoDetails={photoTableData}
        photoTableData={photoTableData}
        isDemo={isDemo}
        MQCityDetails={MQCityDetails}
        qArea={qArea}
        qCity={qCity}
        aprilData={aprilData}
        quarterlyCityTable={quarterlyCityTable}
      />*/}

          {/*<BubbleCompareSecondLeft
          currentArea={currentArea}
          agentData={agentData}
          printVersion={printVersion}
          version={version}
          mlsAreas={mlsAreas}
          hoData={hoData}
          quarterlyAreaTable={quarterlyAreaTable}
          quarterlyCityTable={quarterlyCityTable}
          propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
          oldPhotoDetails={photoTableData}
          photoTableData={photoTableData}
          isDemo={isDemo}
          MQCityDetails={MQCityDetails}
        />*/}
          {/* <MiniTableHotBoxesSecondLeft
        currentArea={currentArea}
        agentData={agentData}
        printVersion={printVersion}
        version={version}
        mlsAreas={mlsAreas}
        hoData={hoData}
        quarterlyAreaTable={quarterlyAreaTable}
        propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
        oldPhotoDetails={photoTableData}
        photoTableData={photoTableData}
        isDemo={isDemo}
        MQCityDetails={MQCityDetails}
        quarterlyCityTable={quarterlyCityTable}
      /> */}
          <YETwoSecondRightV2
            currentArea={currentArea}
            agentData={agentData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            version={version}
            mlsAreas={mlsAreas}
            hoData={hoData}
            quarterlyAreaTable={quarterlyAreaTable}
            quarterlyCityTable={quarterlyCityTable}
            propertyData={propertyData}
            propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
            oldPhotoDetails={photoTableData}
            photoTableData={photoTableData}
            isDemo={isDemo}
            MQCityDetails={MQCityDetails}
            missionStatement={missionStatement}
            demoAccountHOName={demoAccountHOName}
            coverPageDetails={coverPageDetails}
            miniTableDetailsDTO={miniTableDetailsDTO}
            showAllEditButtons={showAllEditButtons}
          />
          {/*<MiniTableHotBoxesSecondLeft
            currentArea={currentArea}
            agentData={agentData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            version={version}
            mlsAreas={mlsAreas}
            hoData={hoData}
            quarterlyAreaTable={quarterlyAreaTable}
            propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
            oldPhotoDetails={photoTableData}
            photoTableData={photoTableData}
            isDemo={isDemo}
            MQCityDetails={MQCityDetails}
            quarterlyCityTable={quarterlyCityTable}
            missionStatement={missionStatement}
            miniTableDetailsDTO={miniTableDetailsDTO}
            coverPageDetails={coverPageDetails}
            fromThirdPage={true}
            showAllEditButtons={showAllEditButtons}
          />*/}
          <YETwoFirstLeft
            auth={auth}
            agentData={agentData}
            hoData={hoData}
            currentArea={currentArea}
            mlsAreas={mlsAreas}
            printVersion={printVersion}
            fromEditor={fromEditor}
            version={version}
            aprilData={aprilData}
            demoAccountHOName={demoAccountHOName}
            demoAccountAreaName={demoAccountAreaName}
            coverPageDetails={coverPageDetails}
            testimonials={testimonials}
            handlePropertyHighlightDialog={handlePropertyHighlightDialog}
            propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
            quarterlyAreaTable={quarterlyAreaTable}
            mlsAreaID={mlsAreaID}
            isDemo={isDemo}
            bubbleBoxes={bubbleBoxes}
            quadrantDetails={quadrantDetails}
            agentFocusInfoList={agentFocusInfoList}
            designDetailsInfoList={designDetailsInfoList}
            quadrantModalOpen={quadrantModalOpen}
            altAgentData={altAgentData}
            volunteerDetails={volunteerDetails}
            miniTableDetailsDTO={miniTableDetailsDTO}
            showAllEditButtons={showAllEditButtons}
          />
          {/* <YETwoSecondRight
        currentArea={currentArea}
        agentData={agentData}
        printVersion={printVersion}
        version={version}
        mlsAreas={mlsAreas}
        hoData={hoData}
        quarterlyAreaTable={quarterlyAreaTable}
        propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
        oldPhotoDetails={photoTableData}
        photoTableData={photoTableData}
        isDemo={isDemo}
        MQCityDetails={MQCityDetails}
        quarterlyCityTable={quarterlyCityTable}
      />*/}
        </div>
      );
    } else {
      return (
        <div
          className={
            "pma-page-container " +
            (printVersion
              ? "ye2-print-page-container"
              : "ye2-pma-editor-page-container") +
            (fromEditor ? " from-editor-column" : "")
          }
        >
          <SecondPageComponents
            currentArea={currentArea}
            hoData={hoData}
            agentData={agentData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            quarterlyAreaTable={quarterlyAreaTable}
            quarterlyCityTable={quarterlyCityTable}
            hasFlippedTeam={hasFlippedTeam}
            aprilData={aprilData}
            MQCityDetails={MQCityDetails}
            dashboardValuation={dashboardValuation}
            tpTrends2WatchList={tpTrends2WatchList}
            miniTableDetailsDTO={miniTableDetailsDTO}
            showAllEditButtons={showAllEditButtons}
            keyMarketAvgsList={keyMarketAvgsList}
            showMedian={showMedian}
            priceRangeDashBoardDetailsDTOArea={
              priceRangeDashBoardDetailsDTOArea
            }
            priceRangeDashBoardDetailsDTOCity={
              priceRangeDashBoardDetailsDTOCity
            }
          />

          {/* <YETwoSecondLeft
        currentArea={currentArea}
        agentData={agentData}
        printVersion={printVersion}
        version={version}
        mlsAreas={mlsAreas}
        hoData={hoData}
        quarterlyAreaTable={quarterlyAreaTable}
        propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
        oldPhotoDetails={photoTableData}
        photoTableData={photoTableData}
        isDemo={isDemo}
        MQCityDetails={MQCityDetails}
        qArea={qArea}
        qCity={qCity}
        aprilData={aprilData}
        quarterlyCityTable={quarterlyCityTable}
      />*/}

          {/*<BubbleCompareSecondLeft
          currentArea={currentArea}
          agentData={agentData}
          printVersion={printVersion}
          version={version}
          mlsAreas={mlsAreas}
          hoData={hoData}
          quarterlyAreaTable={quarterlyAreaTable}
          quarterlyCityTable={quarterlyCityTable}
          propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
          oldPhotoDetails={photoTableData}
          photoTableData={photoTableData}
          isDemo={isDemo}
          MQCityDetails={MQCityDetails}
        />*/}
          {/*< <MiniTableHotBoxesSecondLeft
        currentArea={currentArea}
        agentData={agentData}
        printVersion={printVersion}
        version={version}
        mlsAreas={mlsAreas}
        hoData={hoData}
        quarterlyAreaTable={quarterlyAreaTable}
        propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
        oldPhotoDetails={photoTableData}
        photoTableData={photoTableData}
        isDemo={isDemo}
        MQCityDetails={MQCityDetails}
        quarterlyCityTable={quarterlyCityTable}
      />*/}
          <YETwoSecondRightV2
            currentArea={currentArea}
            agentData={agentData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            version={version}
            mlsAreas={mlsAreas}
            hoData={hoData}
            quarterlyAreaTable={quarterlyAreaTable}
            quarterlyCityTable={quarterlyCityTable}
            propertyData={propertyData}
            propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
            oldPhotoDetails={photoTableData}
            photoTableData={photoTableData}
            isDemo={isDemo}
            MQCityDetails={MQCityDetails}
            missionStatement={missionStatement}
            demoAccountHOName={demoAccountHOName}
            coverPageDetails={coverPageDetails}
            miniTableDetailsDTO={miniTableDetailsDTO}
            showAllEditButtons={showAllEditButtons}
          />
          {/* <MiniTableHotBoxesSecondLeft
            currentArea={currentArea}
            agentData={agentData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            version={version}
            mlsAreas={mlsAreas}
            hoData={hoData}
            quarterlyAreaTable={quarterlyAreaTable}
            propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
            oldPhotoDetails={photoTableData}
            photoTableData={photoTableData}
            isDemo={isDemo}
            MQCityDetails={MQCityDetails}
            quarterlyCityTable={quarterlyCityTable}
            missionStatement={missionStatement}
            miniTableDetailsDTO={miniTableDetailsDTO}
            coverPageDetails={coverPageDetails}
          />*/}

          {/*<YETwoSecondRight
            currentArea={currentArea}
            agentData={agentData}
            printVersion={printVersion}
            version={version}
            mlsAreas={mlsAreas}
            hoData={hoData}
            quarterlyAreaTable={quarterlyAreaTable}
            propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
            oldPhotoDetails={photoTableData}
            photoTableData={photoTableData}
            isDemo={isDemo}
            MQCityDetails={MQCityDetails}
            quarterlyCityTable={quarterlyCityTable}
          />*/}
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    quadrantModalOpen: state.pma.quadrantModalOpen,
    miniTableDetailsDTO: state.pma.miniTableDetailsDTO,
    propertyData: state.pma.propertyData,
    keyMarketAvgsList: state.pma.keyMarketAvgsList,
    priceRangeDashBoardDetailsDTOArea:
      state.pma.priceRangeDashBoardDetailsDTOArea,
    priceRangeDashBoardDetailsDTOCity:
      state.pma.priceRangeDashBoardDetailsDTOCity,
  };
};

// mergeProps — miniTableDetailsDTO (see getPMADetails response: res.data.miniTableDetailsDTO)
//
// Editor version:
//   Parents do not pass miniTableDetailsDTO. It comes from Redux (getPmaDetails / PMA flow).
//
// Print version:
//   PrintPMA calls getPMADetails with axios, keeps miniTableDetailsDTO in component state, and
//   passes it down as props. Redux is often not hydrated on a cold print load.
//
// Why custom merge (not default connect merge):
//   Default merge overwrites parent props with mapStateToProps. If Redux has no DTO yet but the
//   parent passed one from getPMADetails, we must keep the prop — hence
//   ownProps.miniTableDetailsDTO ?? stateProps.miniTableDetailsDTO.
//  In Print version ownProps.miniTableDetailsDTO will contains mini table data but stateProps.miniTableDetailsDTO will be undefined
// In Editor version ownProps.miniTableDetailsDTO will be undefined but stateProps.miniTableDetailsDTO will contain the data
const mergeProps = (stateProps, _dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  miniTableDetailsDTO:
    ownProps.miniTableDetailsDTO ?? stateProps.miniTableDetailsDTO,
  propertyData: ownProps.propertyData ?? stateProps.propertyData,
  keyMarketAvgsList: ownProps.keyMarketAvgsList ?? stateProps.keyMarketAvgsList,
  priceRangeDashBoardDetailsDTOArea:
    ownProps.priceRangeDashBoardDetailsDTOArea ??
    stateProps.priceRangeDashBoardDetailsDTOArea,
  priceRangeDashBoardDetailsDTOCity:
    ownProps.priceRangeDashBoardDetailsDTOCity ??
    stateProps.priceRangeDashBoardDetailsDTOCity,
});

export default connect(mapStateToProps, null, mergeProps)(YETwoSecondPage);
